import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "confirm-message",
  class: "text-sm text-gray-600"
}

import TheModal from '@/components/TheModal.vue'


export default {
  __name: 'ConfirmModal',
  props: {
  isOpen: { type: Boolean, default: false },
  title: { type: String, required: true },
  message: { type: String, default: '' },
  confirmLabel: { type: String, default: 'Confirm' },
  cancelLabel: { type: String, default: 'Cancel' }
},
  emits: ['confirm', 'close'],
  setup(__props) {





return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(TheModal, {
    "is-open": __props.isOpen,
    "modal-title": __props.title,
    "max-width": "max-w-sm",
    onCloseModal: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
  }, {
    main: _withCtx(() => [
      (__props.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.message), 1))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        "data-test": "confirm-cancel",
        class: "btn-ghost justify-center",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
      }, _toDisplayString(__props.cancelLabel), 1),
      _createElementVNode("button", {
        type: "button",
        "data-test": "confirm-accept",
        class: "btn-primary justify-center",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('confirm')))
      }, _toDisplayString(__props.confirmLabel), 1)
    ]),
    _: 1
  }, 8, ["is-open", "modal-title"]))
}
}

}